import { atom } from 'jotai';
import { atomFamily } from 'jotai-family';

export const listingLoadingFamily = atomFamily((_id: number) => atom(false));

export const updateListingLoadingAtom = atom(
  null,
  (get, set, { id, isLoading }: { id: number; isLoading: boolean }) => {
    const loadingAtom = listingLoadingFamily(id);
    set(loadingAtom, isLoading);
  }
);
